import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import CommentActivity from "./contents/comment-activity";
import DiscountCodeActivity from "./contents/discount-code-activity";
import EmailActivity from "./contents/email-activity";
import ErrorActivity from "./contents/error-activity";
import TransactionCapturedActivity from "./contents/transaction-captured-activity";
import UpdateStatusActivity from "./contents/update-status-activity";
import UpdateTreatmentItemActivity from "./contents/update-treatement-item-activity";
import TransactionRefundedActivity from "./contents/transaction-refunded-activity";
import NewLabelActivity from "./contents/new-label-activity";
import WebhookActivity from "./contents/webhook-activity";
import KlaviyoActivity from "./contents/klaviyo-activity";
import GorgiasActivity from "./contents/gorgias-activity";
import LineItemModificationActivity from "./contents/line-item-modification-activity";
import OneStockActivity from "./contents/onestock-activity";
import ShippingBoActivity from "@/pages/(app)/returns/view/components/return-activity/contents/shippingbo-activity.tsx";

import UpdateCarrierActivity from "@/pages/(app)/returns/view/components/return-activity/contents/update-carrier-activity.tsx";
import UpdateDeactivateAutoTreatLogisticianActivity from "@/pages/(app)/returns/view/components/return-activity/contents/update-deactivate-auto-treat-logistician-activity.tsx";
import AutomaticCancellationActivity from "./contents/automatic-cancellation-activity";

type ReturnRequestActivityListItemProps = {
  activity: ReturnRequestLogDto;
  returnRequestId: string;
};

export default function ActivityListItem({
  activity,
  returnRequestId,
}: ReturnRequestActivityListItemProps) {
  switch (activity.type) {
    case "email":
      return <EmailActivity activity={activity} />;
    case "newLabel":
      return <NewLabelActivity activity={activity} />;
    case "updateStatus":
      return <UpdateStatusActivity activity={activity} />;
    case "updateTreatmentItem":
      return <UpdateTreatmentItemActivity activity={activity} />;
    case "comment":
      return <CommentActivity activity={activity} />;
    case "discountCode":
      return <DiscountCodeActivity activity={activity} />;
    case "transactionCaptured":
      return <TransactionCapturedActivity activity={activity} />;
    case "transactionRefunded":
      return <TransactionRefundedActivity activity={activity} />;
    case "error":
      return <ErrorActivity activity={activity} />;
    case "webhook":
      return (
        <WebhookActivity
          activity={activity}
          returnRequestId={returnRequestId}
        />
      );
    case "klaviyo":
      return <KlaviyoActivity activity={activity} />;
    case "gorgias":
      return <GorgiasActivity activity={activity} />;
    case "line-item-modification":
      return <LineItemModificationActivity activity={activity} />;
    case "shippingbo":
      return <ShippingBoActivity activity={activity} />;
    case "onestock":
      return (
        <OneStockActivity
          activity={activity}
          returnRequestId={returnRequestId}
        />
      );
    case "updateCarrier":
      return <UpdateCarrierActivity activity={activity} />;
    case "updateDeactivateAutoTreatLogistician":
      return (
        <UpdateDeactivateAutoTreatLogisticianActivity activity={activity} />
      );
    case "automaticCancellation":
      return <AutomaticCancellationActivity activity={activity} />;
    default:
      return null;
  }
}
